import * as WakeWordException from '@amzn/ihm-associate-tools-js-lib'

export const errorCodeToExceptionsMapping = Object.freeze({
    0: WakeWordException.WakeWordListeningInterruptedException,
    1: WakeWordException.WakeWordValidUnknownActionException,
    2: WakeWordException.WakeWordUnknownActionException,
    3: WakeWordException.WakeWordInvalidActionException,
    4: WakeWordException.WakeWordInitializationUnavailableException,
    5: WakeWordException.WakeWordListeningUnavailableException,
    6: WakeWordException.WakeWordDetectionFailureException,
})

export const errorCodeToMetricNamesMapping = Object.freeze({
    0: 'ListeningInterrupted',
    1: 'ValidUnknownAction',
    2: 'UnknownAction',
    3: 'InvalidAction',
    4: 'InitializationUnavailable',
    5: 'ListeningUnavailable',
    6: 'DetectionFailure',
})

export class CandyCaneWakeWordErrorMappings {

    /**
     *  Get exception by mapping with error code.
     * @param error     error with errorCode and errorMessage
     * @returns         exception mapped with error code.
     *                  If code is not found from the mapping, return WakeWordUnknownErrorException
     */
    public static getExceptionForError (error) {
        if (errorCodeToExceptionsMapping.hasOwnProperty(error.errorCode)) {
            console.error('Received error: ',error.errorMessage)
            return new errorCodeToExceptionsMapping[error.errorCode]({
                message: error.errorMessage,
            })
        }

        console.error('Unknown error ', error)
        return new WakeWordException.WakeWordUnknownErrorException({
            message: error.errorMessage,
        })
    }

    /**
     *  Get metric name by mapping with error code.
     * @param error     error with errorCode and errorMessage
     * @returns         metric name mapped with error code.
     *                  If code is not found from the mapping, return WakeWordUnknownError
     */
    public static getMetricNameForError (error) {
        if (errorCodeToMetricNamesMapping.hasOwnProperty(error.errorCode)) {
            return errorCodeToMetricNamesMapping[error.errorCode]
        }

        return 'Unknown error'
    }
}
